$(document).ready(function(){
  $('a[href$=".pdf"]').attr('download', '');
})



// WEBPACK FOOTER //
// ./assets/js/pdf-links.js